export const MAX_PAGE_SIZE_FOR_PAGINATED_FILTER_QUERIES = 3500;

export const TEACHER_FILTER_ID_SEARCH_PARAM = "teacher_filter_id";

// The Main Idea reading skill content_id
export const MAIN_IDEA_READING_SKILL_CONTENT_ID = "ckmmfdxcj00033e5aq2r9soen";

export const AVAILABLE_CLASSROOM_READING_ACTIVITY_SORTING_KEYS = {
  student: "student-name",
  views: "articles-viewed-count",
  textLevel: "article-lexile-level-viewed-average",
  activeTime: "article-time-average",
  quizzes: "quizzes-completed-count",
  quizScores: "quizzes-completed-score-average",
  writePromptScore: "write-prompts-score-average",
  annotations: "annotations-avg-count-by-text-level",
  powerWordsScore: "powerwords-quiz-score-average",
};

export const AVAILABLE_CLASSROOM_ALL_CONTENT_ACTIVITY_SORTING_KEYS = {
  student: "student-name",
  textLevel: "article-lexile-level-viewed-average",
  textViews: "text-levels-viewed-count",
  activeTime: "text-level-time-average-seconds",
  videosViewed: "videos-viewed-count",
  videoTime: "video-time-average-seconds",
  interactivesViewed: "interactives-viewed-count",
  quizzes: "quizzes-completed-count",
  quizScores: "quizzes-completed-score-average",
  writePromptScore: "write-prompts-score-average",
  annotations: "annotations-avg-count-by-text-level",
};

export const AVAILABLE_CLASSROOM_STEM_ACTIVITY_SORTING_KEYS = {
  student: "student-name",
  textLevel: "article-lexile-level-viewed-average",
  lastActivity: "last-activity-date",
  articlesViewed: "articles-viewed-count",
  articleTime: "article-time-average-seconds",
  videosViewed: "videos-viewed-count",
  videoTime: "video-time-average-seconds",
  interactivesViewed: "interactives-viewed-count",
};

export const AVAILABLE_STUDENT_STEM_ACTIVITY_SORTING_KEYS = {
  content: "content-title",
  textLevel: "article-lexile-level",
  lastActivity: "viewing-session-date",
  activeTime: "viewing-time-in-session-seconds",
};

export const AVAILABLE_STUDENT_READING_ACTIVITY_SORTING_KEYS = {
  content: "content-title",
  viewedDate: "reading-session-date",
  textLevel: "article-lexile-level",
  time: "reading-session-time",
  quizScore: "quiz-score",
  quizCompletionDate: "quiz-completion-date",
  writePromptScore: "write-prompt-score",
  annotations: "annotations-submitted-count",
  powerWordsScore: "powerwords-quiz-score",
};
